import React from 'react';
import CheckBox from './Checkbox';
import langConf from "../js/lang";

class BidItems extends React.Component {

    state= {color: this.props.includeBidItems ? 'blue' : 'grey'};
    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    changeTableColor = (color) => {
        this.setState({color: color});
    };

    render() {
        let lang = this.props.lang;
        let itemCount = 0;
        let itemSum = 0;
        let currency = this.props.currency === 'ILS' ? langConf[lang].ILS : langConf[lang].USD;
        this.props.bidItems.map((item)=> itemCount += item.quantity);
        this.props.bidItems.map((item)=> itemSum += this.props.currency === "ILS" ? (item.priceNis === null || item.priceNis === '' ? 0 : (item.priceNis * item.quantity)) : (item.Usd === null || item.Usd === '' ? 0 : (item.priceUsd * item.quantity)));
        let index = 0;

        // Default sizes
        let tableLeftPadding = '300px';
        let tableRightPadding = '300px';
        //console.log('window.innerWidth: ', window.innerWidth);
        if (window.innerWidth >= 0 && window.innerWidth <= 480) {// Small phones: form 0px to 480px 
            tableLeftPadding = '0px';
            tableRightPadding = '0px';
        }
        else if (window.innerWidth >= 481 && window.innerWidth <= 767) {// Small phones to small tablets: form 481px to 767px 
            tableLeftPadding = '0px';
            tableRightPadding = '0px';
        }
        else if (window.innerWidth >= 768 && window.innerWidth <= 1023) {// Small tablets to big tablets: form 768px to 1023px
        
        }
        else if (window.innerWidth <= 1200) {// Big tablets to 1200px (widths smaller than the 1140px row) 
        
        }
        const items = this.props.bidItems.map((item)=>{
            index++;
            return (
                <tr key={`${index}.  ${item.itemNo}`}>
                        <td style={{display: 'none'}}>{item.itemNo}</td>
                        <td>{`[${item.cartItemDate}]`}</td>
                        <td>{` ${item.itemDescription}`}</td>
                        <td>{item.quantity}</td>
                        <td>{`${this.numberWithCommas(this.props.currency === "ILS" ? ((item.priceNis === null ? 0 : item.priceNis) * item.quantity) : ((item.priceUsd === null ? 0 : item.priceUsd) * item.quantity))} ${currency}`}</td>
                    </tr>
                )});
        return (
            <div>
                <div style={{paddingRight: `${tableRightPadding}`, paddingLeft: `${tableLeftPadding}`, textAlign: 'center', display: itemCount > 0 ? '' : 'none'}}>
                    <h1>{langConf[lang].formerCart}</h1>
                    <table className={`ui inverted ${this.state.color} large unstackable table right`} style={{textAlign: langConf[lang].right}}>
                        <thead>
                            <tr>
                                <th scope="col" style={{display: 'none'}}>{langConf[lang].itemNo}</th>
                                <th scope="col">
                                    <CheckBox 
                                        lang={lang} 
                                        label={langConf[lang].formerCart} 
                                        forBid={true} 
                                        changeBidIncluded={this.props.changeBidIncluded} 
                                        includeBidItems={this.props.includeBidItems} 
                                        changeTableColor={this.changeTableColor}
                                    />
                                </th>
                                <th scope="col">{langConf[lang].itemName}</th>
                                <th scope="col">{langConf[lang].quantity}</th>
                                <th scope="col">{langConf[lang].price}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th></th>
                                <th>{langConf[lang].subtotal}</th>
                                <th>{itemCount}</th>
                                <th>{`${this.numberWithCommas((itemSum === null ? 0 : itemSum))} ${currency}`}</th>
                            </tr>
                        </tfoot>
                    </table>
                
            </div>
        </div>
        );
    }
}

export default BidItems;